import { render, staticRenderFns } from "./pending-audit.vue?vue&type=template&id=6da6896e"
import script from "./pending-audit.vue?vue&type=script&lang=js"
export * from "./pending-audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports